import { commonShortFieldLabels, commonShortNouns } from "./common-short-fields";

export const examAdminExecutionAttackDefense = {
  pageTitle: "Attack & Defense Environment Panel",
  pageSubtitle: "View attack-defense environment creation records and flag submission records.",
  sourceExam: "Exam",
  sourceDebug: "Debug",
  statsTotal: "Total: {count}",
  statsRunning: "Running: {count}",
  statsDestroyed: "Destroyed: {count}",
  statsDynamic: "Dynamic flag: {count}",
  statsStatic: "Static flag: {count}",
  columns: {
    instanceId: "Instance ID",
    source: "Source",
    examInfo: "Exam",
    question: "Question",
    questionVersionCode: "Question Version Code",
    candidate: "Candidate",
    status: commonShortNouns.status,
    containerId: "Container ID",
    webEndpoint: "Web Endpoint",
    imageName: "Image",
    flagMode: "Flag Mode",
    flagEnvKey: "Flag Env Key",
    flagValue: "Flag",
    flagSha256: "Flag Hash",
    creator: "Creator",
    lifetime: "Lifetime",
    startedAt: "Started At",
    createdAt: commonShortFieldLabels.createdAt,
    expiresAt: "Expires At",
    destroyedAt: "Destroyed At",
    actions: "Actions",
  },
  actions: {
    viewFlagSubmissions: "Flag Submissions",
    viewAttempt: "View Attempt",
    recycleInstance: "Recycle",
  },
  messages: {
    recycleSubmissionSubmitted: "Environment destroy request submitted",
  },
  flagSubmissionsTitle: "Flag submissions (Instance #{id})",
  flagSubmissionsEmpty: "No flag submissions",
  flagSubmissionColumns: {
    id: "ID",
    flagValue: "Flag",
    result: "Result",
    submittedAt: "Submitted At",
  },
  resultCorrect: "Correct",
  resultIncorrect: "Incorrect",
  resultUnknown: "Unknown",
  statusRunning: "Running",
  statusReady: "Ready",
  statusEvaluated: "Evaluated",
  statusProvisioning: "Provisioning",
  statusPending: "Pending",
  statusDestroyed: "Destroyed",
  statusDebug: "Debugging",
  flagModeDynamic: "Dynamic",
  flagModeStatic: "Static",
  examInfoEmpty: "Debug instance",
} as const;
